<template>
  <div v-loading="loading" :element-loading-text="schedule + ' / 100'" element-loading-spinner="el-icon-loading">
    <!-- 商品文件管理 -->
    <!-- 创建文件分类 -->
    <div class="btn">
      <el-button type="success" @click="createFileClassification"> {{ $t('message.createFileClassification')
      }}</el-button>
    </div>
    <div class="item-body" v-for="(item, index) in detail.client_product_file_cate" :key="index">
      <!-- 商品定制文件 -->
      <div class="name">
        <div class="input">
          <input type="text" v-model="item.cate_name">
        </div>
      </div>
      <div class="file-list">
        <div class="item" v-for="(file, fileIndex) in item.files" :key="fileIndex">
          <i class="el-icon-document-checked">
          </i>
          <i class="el-icon-error" @click="fileDelete(index, fileIndex)"></i>
          <p class="word-break">
            <a :href="file.url" target="_blank" rel="noopener noreferrer" class="a-link">{{ file.name }}</a>
          </p>
        </div>
        <div class="upload" @click="fileIndex = index">
          <!-- 上传文件 -->
          <el-upload action="https://jsonplaceholder.typicode.com/posts/" multiple drag :http-request="httpFile"
            :show-file-list="false">
            <el-button type="primary">{{ $t('message.uploadFiles') }}</el-button>
          </el-upload>
        </div>
      </div>
    </div>
    <!--  -->
    <!-- 创建分类 -->
    <el-dialog :title="$t('message.createFileClassification')" :close-on-click-modal="false"
      :visible.sync="dialogVisible" width="400px">
      <el-input type="textarea" v-model="cate_name"></el-input>
      <span slot="footer" class="dialog-footer">

        <!--取 消  -->
        <el-button @click="dialogVisible = false">
          {{ $t("message.cancel") }}
        </el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="fileCateStore">
          {{ $t("message.ok") }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
  computed: {
    ...mapState(['schedule'])
  },
  data() {
    return {
      detail: {
        client_product_file_cate: []
      },
      loading: false,
      fileIndex: 0,//索引
      dialogVisible: false,
      cate_name: '',
    };
  },
  methods: {
    // 设置数据
    setData(sys_code_set) {
      let datas = {
        sys_code_set,
        list: this.detail.client_product_file_cate
      }
      this.$api.productManagementApi.batchUpdateFile(datas).then(res => {
        this.$message.success(res.msg)
      })

    },
    // 创建文件分类
    fileCateStore() {
      if (this.cate_name == '') return this.$message.error('为填写分类')
      this.detail.client_product_file_cate.push({
        cate_name: this.cate_name,
        files: []
      })
      this.dialogVisible = false

    },
    // 新增分类
    createFileClassification() {
      if (this.detail.client_product_file_cate.length > 3) return this.$message.error('文件夹最多创建3个')
      this.cate_name = ''
      this.dialogVisible = true
    },
    // 数据维护-文件分类修改
    fileCateUpdate(item) {
      let datas = {
        user_id: this.detail.user_id,
        sys_code: this.detail.sys_code,
        id: item.id,
        cate_name: item.cate_name,
      }
      this.$api.productManagementApi.fileCateUpdate(datas)
    },
    // 上传文件
    async httpFile(file) {
      this.loading = true
      let data = await this.createClient(file)
      this.loading = false
      this.detail.client_product_file_cate[this.fileIndex].files.push({
        url: data.data,
        name: file.file.name,
      })
    },
    // 删除
    fileDelete(index, fileIndex) {
      this.fileIndex = index
      this.detail.client_product_file_cate[index].files.splice(fileIndex, 1)
    },

  }
}
</script>
<style lang='scss' scoped>
.btn {
  margin-bottom: 12px;
  text-align: right;
}

.item-body {
  padding: 24px;
  border: 1px solid #dedede;
  border-radius: 10px;
  margin-bottom: 24px;

  .name {
    display: flex;

    margin-bottom: 24px;

    input {
      border: 1px solid #DCDFE6;
      border-radius: 6px;
      width: 200px;
      height: 38px;
      padding: 0 20px;
      margin-right: 20px;
    }
  }

  .file-list {
    display: flex;

    .item {
      position: relative;
      margin-right: 50px;

      width: 100px;

      .el-icon-document-checked {
        font-size: 100px;
      }

      .el-icon-error {
        font-size: 20px;
        color: #B4272B;
        position: absolute;
        top: -5px;
        right: -5px;
        cursor: pointer;
      }

      p {
        margin-top: 12px;
        height: 40px;
        line-height: 20px;
        overflow: hidden;
        /* 隐藏超出部分 */
        display: -webkit-box;
        /* 使用Webkit的盒模型 */
        -webkit-line-clamp: 2;
        /* 限制最多显示两行 */
        -webkit-box-orient: vertical;
        /* 设置盒模型的方向为垂直 */
      }
    }

    .upload {
      display: flex;
      justify-content: center;
      align-items: center;

      /deep/.el-upload-dragger {
        width: auto;
        height: auto;
        border: none;
      }
    }


  }
}
</style>